import React from "react";
import { Div, Text, Row, Col, Button, Image } from "atomize";

import CustomContainer from "../common/CustomContainer";
import WebsiteContainer from "../common/WebsiteContainer";
import AnimateLink from "../common/AnimateLink";
import Swiper from "react-id-swiper";
import PrimaryButton from "../common/PrimaryButton";
import Div100vh from "react-div-100vh";

const HomeHeroSwiper = hero => {
  const params = {
    slidesPerView: 1,
    loop: true,
    initialSlide: 0,
    loadOnTransitionStart: true,
    loadPrevNextAmount: 1,
    lazy: true,
    effect: "fade",
    speed: 700,
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
  };

  const homeHeroImages = [
    "https://s3-alpha-sig.figma.com/img/9ffd/ce4d/5adff568e2e679afec732456bf9f8dba?Expires=1600041600&Signature=MbceH-R~5SA1UY7yqfzlThbEpZ5RtthdJqIRfPDQc23ayHWkK0VC9EFRGCIBhCsTRFT3Fck6JlHoX2qfPr1GU8Lb4FZ8O1~6I00y0AX2EaDHVE6n7WM29j67kcTP3Z5ZfQTEAM~7kKKAj23PkG6Jndr7AWyK8gaz~gvwzEoXaXA-nIXfxZ7iBf0zAiAYYXbtGr8k7pHDvmcUwmc~JYT-ZHQZJ7-qmG~ku1pmsPF2y4wxnOIWnmQeilEoSfNu0uOlk0gAs~cJuFZtLbOumz2wfcemw4xM1RaZkiTmbzc~BpI8fGHtA8IAf4jvACRn6o9f9UiSsarKC3ImtI8epXjjHg__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
    "http://images.ctfassets.net/vlf899vyq9qs/lKCfeYZraQG95jcPAAWcQ/47535146d7b389fb2acdf0dfd7524898/creators-hero.jpg",
    "http://images.ctfassets.net/vlf899vyq9qs/3cuDXy44TY4ZKTDumZ5zk0/04a5440a36a05186ba58f10b7a14ad38/Lydt_2x.jpg",
    "http://images.ctfassets.net/vlf899vyq9qs/5EmYwUjINI0wJR51ctLnde/4c5df63ef49265d4207eb473296c5f47/Moonultra_2x.jpg",
  ];

  return (
    <Div className="home-hero-swiper" pos="relative">
      <Swiper {...params}>
        {hero.hero.homeHeroImages.map((image, index) => (
          <Div
            key={`slide-bg-home-${index}`}
            className="home-bg-slide hero-container"
          >
            <Div h={{ xs: "90vh", md: "75vh" }} className="hero-image-content">
              <Div
                className="hero-bg-image"
                // d={{ xs: "none", md: "block" }}
                pos="absolute"
                top="0"
                left="0"
                bgImg={image}
                w="100%"
                p={{ b: "90vh" }}
                bgSize="cover"
                bgPos={{ xs: "80% 50%", md: "center" }}
              />
              {/* <Div
              d={{ xs: 'block', md: 'none' }}
              pos="absolute"
              top="0"
              left="0"
              bgImg={slide.mobileImage}
              w="100%"
              p={{ b: '80vh' }}
              bgSize="cover"
              bgPos="center"
            /> */}
            </Div>
          </Div>
        ))}
      </Swiper>
      <Div
        pos="absolute"
        bottom={{ xs: "5rem", md: "2.5rem" }}
        padding=" env(safe-area-inset-top) env(safe-area-inset-right)
          env(safe-area-inset-bottom) env(safe-area-inset-left)"
        left="0"
        w="100%"
        zIndex="12"
      >
        <WebsiteContainer>
          <CustomContainer>
            <Div
              className="hero-swiper-content"
              w={{ xs: "100%", md: "50%" }}
              // m={{ b: { xs: "0", md: "5.5rem" } }}
              zIndex="12"
            >
              <Div>
                <Text
                  tag="h1"
                  textColor="white"
                  textWeight="300"
                  className="hero-title"
                  textAlign={{ xs: "center", md: "left" }}
                >
                  {hero.hero.heroTitle}
                </Text>
              </Div>
              <Div m={{ t: "2.125rem" }} d={{ md: "flex" }} align="center">
                <Div>
                  <PrimaryButton
                    className="hero-action-btn"
                    bg="primary"
                    fontFamily="primary"
                    hoverBg="#FFCB6F"
                    textTransform="none"
                    textColor="black"
                    h="3.125rem"
                    border="none"
                    w="100%"
                    onClick={() =>
                      (window.location.href = hero.hero.heroBtnPrimary.link)
                    }
                  >
                    {hero.hero.heroBtnPrimary.text}
                  </PrimaryButton>
                </Div>
                <Div>
                  <PrimaryButton
                    className="hero-action-btn secondary"
                    bg="white"
                    hoverBg="lightGray"
                    w="100%"
                    h="3.125rem"
                    textColor="black"
                    textTransform="none"
                    border="none"
                    onClick={() =>
                      (window.location.href = hero.hero.heroBtnSecondary.link)
                    }
                  >
                    {hero.hero.heroBtnSecondary.text}
                  </PrimaryButton>
                </Div>
              </Div>
              <Div
                className="hero-sub-text"
                m={{ t: "0.6rem" }}
                style={{ lineHeight: "1.5rem" }}
                textAlign={{ xs: "center", md: "left" }}
              >
                {hero.hero.heroSubText}
              </Div>
            </Div>
          </CustomContainer>
        </WebsiteContainer>
      </Div>
    </Div>
  );
};

export default HomeHeroSwiper;
